export const TELEMETRY_DEFAULT_SORT = { sortBy: "sha256", orderBy: "asc" };
